import type { Tag } from '@carboncopyco/types';
import { Capsule } from '@carboncopyco/ui';

export const WorkspacesPageTagsCell = ({ tags }: { tags: Tag[] }) => {
  return tags.length > 4 ? (
    <div className="flex gap-2">
      <div className="max-w-1/2">
        <Capsule
          interactive={false}
          small
          label={tags[0].name}
          ellipsis
        />
      </div>
      <div className="max-w-1/2">
        <Capsule
          tooltipLabel={tags.map((tag) => tag.name)?.join(', ')}
          interactive={false}
          small
          label={`+${tags.length - 1}`}
          ellipsis
        />
      </div>
    </div>
  ) : (
    <div className="flex gap-2">
      {tags?.slice(0, 4).map((tag) => (
        <div
          key={tag.id}
          className="max-w-[80px]"
        >
          <Capsule
            interactive={false}
            small
            label={tag.name}
            ellipsis
          />
        </div>
      ))}
    </div>
  );
};
